"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0m-8.5-5v4.434a1.5 1.5 0 0 0 .728 1.286l2.015 1.209a.5.5 0 1 0 .514-.858l-2.014-1.208a.5.5 0 0 1-.243-.43V7a.5.5 0 0 0-1 0"
}), 'ClockFilled');
//# sourceMappingURL=index.js.map